// extracted by mini-css-extract-plugin
export var assigneeBadge = "_lk-0";
export var assigneeDetails = "_lk-1";
export var assigneeInfo = "_lk-2";
export var dropdownContainer = "_lk-4";
export var dropdownImage = "_lk-5";
export var editAssigneeInfo = "_lk-3";
export var editAssigneeModalContainer = "_lk-6";
export var hidden = "_lk-8";
export var input = "_lk-7";